import IdentityCollection from 'owa-service/lib/contract/IdentityCollection';
import Identity from 'owa-service/lib/contract/Identity';

/**
 * Helper to extract identities from raw identity ids
 * @param rawIdentities  - raw identities of the retention policy tags
 */
export default function configureIdentityCollection(rawIdentities: string[]): IdentityCollection {
    const identities = rawIdentities
        .map(id => <Identity>{ RawIdentity: id })
        .reduce((collection, identity) => {
            collection.push(identity);
            return collection;
        }, []);
    return { Identities: identities };
}
